import { Injectable } from "@angular/core";
import { NgbModal, NgbModalOptions } from "@ng-bootstrap/ng-bootstrap";
import { ConfirmationDialogComponent } from "../confirmation-dialog/confirmation-dialog.component";
@Injectable({
  providedIn: "root",
})
export class ConfirmationDialogService {
  constructor(private modalService: NgbModal) {}

  public confirm(
    title: string,
    message: string,
    btnOkText: string = "OK",
    btnCancelText: string = "CANCEL",
    dialogSize: "sm" | "lg" = "sm",
    btnCloseShow: boolean = true,
    btnCancelShow: boolean = true
  ): Promise<boolean> {
    const ngbModalOptions: NgbModalOptions = {
      backdrop : 'static',
      keyboard: false,
      centered: true
    };
    
    const modalRef = this.modalService.open(ConfirmationDialogComponent, ngbModalOptions);
    modalRef.componentInstance.title = title;
    modalRef.componentInstance.message = message;
    modalRef.componentInstance.btnOkText = btnOkText;
    modalRef.componentInstance.btnCancelText = btnCancelText;
    modalRef.componentInstance.btnCloseShow = btnCloseShow;
    modalRef.componentInstance.btnCancelShow = btnCancelShow;
    return modalRef.result;
  }
}
